var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 330",
    style: {
      enableBackground: "new 0 0 330 330"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165,0C74,0,0,74,0,165s74,165,165,165s165-74,165-165S256,0,165,0z M165,300c-74.4,0-135-60.6-135-135 S90.6,30,165,30s135,60.6,135,135S239.4,300,165,300z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165,70c-11,0-20,9-20,20s9,20,20,20s20-9,20-20S176,70,165,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165,140c-8.3,0-15,6.7-15,15v90c0,8.3,6.7,15,15,15s15-6.7,15-15v-90C180,146.7,173.3,140,165,140z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.808859508cff5562856c187c3cfdffc4.svg";
export { ForwardRef as ReactComponent };